import { Badge, Group } from "@mantine/core";
import { IconArticle, IconMicrophone2 } from "@tabler/icons-react";
import type { PostType } from "../../types/post";

interface Props {
  postType: PostType;
  podcastNumber?: number | null;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
}

// Content-type badges are intentionally quiet: cover art already communicates
// blog-vs-podcast for most cards, so we frame the type with a tiny icon and a
// muted neutral fill instead of a loud brand or off-brand color. See issue #110.
const SUBTLE_STYLES = {
  root: {
    background: "rgba(255, 255, 255, 0.06)",
    border: "1px solid rgba(255, 255, 255, 0.14)",
    color: "var(--ink-body)",
    textTransform: "uppercase" as const,
    letterSpacing: "0.04em",
    fontWeight: 600,
  },
};

const iconSizeFor = (size: NonNullable<Props["size"]>) =>
  size === "xs" || size === "sm" ? 11 : 13;

export function PostTypeBadges({ postType, podcastNumber, size = "sm" }: Props) {
  const showBlog = postType === "blog" || postType === "both";
  const showPodcast = postType === "podcast" || postType === "both";
  const iconSize = iconSizeFor(size);

  return (
    <Group gap={6}>
      {showBlog && (
        <Badge
          size={size}
          radius="sm"
          styles={SUBTLE_STYLES}
          leftSection={<IconArticle size={iconSize} stroke={2} />}
        >
          Blog
        </Badge>
      )}
      {showPodcast && (
        <Badge
          size={size}
          radius="sm"
          styles={SUBTLE_STYLES}
          leftSection={<IconMicrophone2 size={iconSize} stroke={2} />}
        >
          Podcast{podcastNumber ? ` · Ep. ${podcastNumber}` : ""}
        </Badge>
      )}
    </Group>
  );
}

export default PostTypeBadges;
